import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['item'];

  connect() { }

  download(event) {
    event.preventDefault()
    event.stopPropagation();
    window.location.href = event.target.dataset.downloadUrl
  }

  copyUrl(event) {
    event.preventDefault()
    event.stopPropagation();
    navigator.clipboard.writeText(event.target.dataset.copyUrl)
    this.createToast({ color: 'success', message: 'URL was copied' });
  }

  delete(event) {
    event.preventDefault()
    event.stopPropagation();
    if (event.target.dataset.restrictModification === 'true') {
      alert("You cannot delete this folder since it was created automatically by Bookkeeper360.");
      return;
    }
    this.request('DELETE', event.target.dataset.deleteUrl, event.target.dataset.id)
  }

  restore(event) {
    event.preventDefault();
    event.stopPropagation();

    this.request('PATCH', event.target.dataset.restoreUrl, event.target.dataset.id)
  }

  request(method, url, itemId) {
    fetch(url, {
      method,
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response) => {
      if (!response.ok) { return; }

      return response.json().then(({ color, message }) => {
        this.createToast({ color, message });
        if (color === 'success') {
          document.querySelector(`[data-item-id="${itemId}"]`).style.display = 'none';
        }
      })
    })
  }

  createToast({ color, message }) {
    const template = document.createElement('template')
    template.innerHTML = this.buildToast(color).trim()
    template.content.querySelector('.toast-body').textContent = message
    document.getElementById('toast-container').append(template.content)
  }

  buildToast(color) {
    return `
      <div class="toast show align-items-center text-white bg-${color} border-0 mb-4 me-4" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="d-flex">
          <div class="toast-body"></div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
      </div>
    `
  }
}
